export type Language = "en" | "es" | "hi";

const LANGUAGE_COLORS: Record<Language, string> = {
  en: "var(--text-muted)",
  es: "var(--info, #3b82f6)",
  hi: "var(--warning, #d97706)",
};

const LANGUAGE_LABELS: Record<Language, string> = {
  en: "EN",
  es: "ES",
  hi: "HI",
};

export function LanguageBadge({ language }: { language: Language }) {
  const color = LANGUAGE_COLORS[language] ?? "var(--text-muted)";
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 4,
        fontSize: 10,
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: 0.5,
        color,
        background: `color-mix(in srgb, ${color} 12%, transparent)`,
        border: `1px solid color-mix(in srgb, ${color} 25%, transparent)`,
      }}
    >
      {LANGUAGE_LABELS[language] ?? language.toUpperCase()}
    </span>
  );
}
